<template>
<div class="chapter">
<div class="inner_page">
<p class="label"><a id="page_9"></a><a id="pt1"></a><strong>PART I</strong></p>
<p class="h2a"><strong>THE RISE OF THE GHETTO, 1890–1915</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226160702_10_pt1.vue?42cabeb2